import { render, staticRenderFns } from "./Administrasi.vue?vue&type=template&id=a71dc4e6&"
import script from "./Administrasi.vue?vue&type=script&lang=js&"
export * from "./Administrasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports